import { NgModule } from '@angular/core';
import { ImagesItensComponent } from './images-itens/images-itens';
import { InputImageComponent } from './input-image/input-image';
import { CardItemComponent } from './card/card-item';

@NgModule({
	declarations: [ImagesItensComponent,
    InputImageComponent,
    CardItemComponent,
    ],
	imports: [],
	exports: [ImagesItensComponent,
    InputImageComponent,
    CardItemComponent,
    ]
})
export class ComponentsModule {}
